import { createFileRoute } from "@tanstack/react-router"
import IncomingOrdersCalendar from "~/components/purchaseOrder/incomingOrders/IncomingOrdersCalendar"
import { usePageTracking } from "../../../../../hooks/usePageTracking"

export const Route = createFileRoute("/_auth/procurement/incoming-orders/_layout/calendar")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Incoming Orders Calendar")
  return <IncomingOrdersCalendar />
}
